import { render, staticRenderFns } from "./card-layout.vue?vue&type=template&id=30961bc4"
import script from "./card-layout.vue?vue&type=script&lang=js"
export * from "./card-layout.vue?vue&type=script&lang=js"
import style0 from "./card-layout.vue?vue&type=style&index=0&id=30961bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports